module.exports = __webpack_public_path__ + "static/media/error2.d6d5c839.png";